var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.providerId)?_c('header-bar',{attrs:{"webinfo":_vm.webinfo}}):_vm._e(),_c('router-view',{attrs:{"webinfo":_vm.webinfo}}),(_vm.providerId)?_c('footer-bar',{attrs:{"webinfo":_vm.webinfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }